/*
  Shoes Egy — quick add from a product card.

  The "+" on a card (snippets/shoes-egy-brand-card.liquid) carries the
  product's sizes as JSON. This shows them in the dialog from
  snippets/shoes-egy-quick-add.liquid, adds the chosen size through
  /cart/add.js and publishes Dawn's cartUpdate, so the header count moves as
  it does from the product page. The click is caught on the document, so
  cards added later (Load more, the Saved page) work too.
*/
(function () {
  var qa = document.querySelector('[data-qa]');
  if (qa && typeof qa.showModal === 'function') {
    var qaVariant = null;
    var qaSize = '';
    var qaOpener = null;
    var pick = qa.querySelector('[data-qa-pick]');
    var done = qa.querySelector('[data-qa-done]');
    var addBtn = qa.querySelector('[data-qa-add]');
    var addLabel = qa.querySelector('[data-qa-add-label]');
    var addAr = qa.querySelector('[data-qa-add-ar]');
    var errorEl = qa.querySelector('[data-qa-error]');
    var setText = function (sel, text) { qa.querySelector(sel).textContent = text || ''; };

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick]');
      if (!btn) return;
      var data;
      try { data = JSON.parse(btn.getAttribute('data-quick')); } catch (err) { return; }
      qaOpener = btn;
      qaVariant = null;
      var img = qa.querySelector('[data-qa-img]');
      img.src = data.image || '';
      img.hidden = !data.image;
      setText('[data-qa-brand]', data.brand);
      setText('[data-qa-model]', data.model);
      setText('[data-qa-colour]', data.colour);
      setText('[data-qa-price]', data.price);
      qa.querySelector('[data-qa-full]').href = data.url;
      var list = qa.querySelector('[data-qa-sizes]');
      list.innerHTML = '';
      data.variants.forEach(function (v) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = v[1];
        b.setAttribute('aria-pressed', 'false');
        if (!v[2]) { b.disabled = true; b.setAttribute('aria-label', v[1] + ' — sold out'); }
        b.addEventListener('click', function () {
          list.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          qaVariant = v[0];
          qaSize = v[1];
          addBtn.disabled = false;
          addLabel.textContent = 'Add EU ' + v[1] + ' to bag';
          addAr.textContent = 'ضيف مقاس ' + v[1] + ' للشنطة';
        });
        li.appendChild(b);
        list.appendChild(li);
      });
      // a single size needs no choosing
      var open = data.variants.filter(function (v) { return v[2]; });
      addBtn.disabled = true;
      addLabel.textContent = 'Select a size';
      addAr.textContent = 'اختار المقاس الأول';
      if (open.length === 1) list.querySelector('button:not(:disabled)').click();
      errorEl.hidden = true;
      pick.hidden = false;
      done.hidden = true;
      qa.showModal();
    });

    addBtn.addEventListener('click', function () {
      if (!qaVariant) return;
      addBtn.disabled = true;
      errorEl.hidden = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: qaVariant, quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (body) { if (!r.ok) throw new Error(body.description || body.message || 'error'); return body; });
      }).then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: cart });
        }
        var ok = qa.querySelector('[data-qa-ok]');
        ok.textContent = 'Added EU ' + qaSize + ' to your bag';
        var ar = document.createElement('span');
        ar.className = 'shoes-ar';
        ar.lang = 'ar';
        ar.dir = 'rtl';
        ar.textContent = 'اتضاف مقاس ' + qaSize + ' للشنطة';
        ok.appendChild(ar);
        pick.hidden = true;
        done.hidden = false;
      }).catch(function (err) {
        errorEl.textContent = (err && err.message && err.message !== 'error' ? err.message + ' — ' : '') + 'Could not add it. Try again. · ماقدرناش نضيفه، جرّب تاني.';
        errorEl.hidden = false;
        addBtn.disabled = false;
      });
    });

    qa.querySelectorAll('[data-qa-close]').forEach(function (b) { b.addEventListener('click', function () { qa.close(); }); });
    qa.addEventListener('click', function (e) {
      if (e.target !== qa) return;
      var r = qa.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) qa.close();
    });
    qa.addEventListener('close', function () { if (qaOpener) qaOpener.focus(); });
  }
})();
